export class PickUpInformation {
  earliestPickupTime: string;
  latestPickupTime: string;
  pickupInstruction: string;
}
